import { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'

export function checkIsClosed(
  salesFunnelStage: string | null | undefined,
): boolean {
  if (!salesFunnelStage) return false
  const stage = salesFunnelStage.toLowerCase()
  return (
    stage === LEAD_STATUSES.Disqualified ||
    stage === 'closed/won' ||
    stage === 'closed/lost'
  )
}
